module.exports = __webpack_public_path__ + "static/media/17.0b155f9d.svg";